import * as Yup from "yup";

const TreinamentoIACadastrarSchema = Yup.object({
    texto: Yup.string().required({ name: "texto", err: "Campo com preenchimento obrigatório" }),
    prioridade: Yup.number().required({ name: "prioridade", err: "Campo com preenchimento obrigatório" }),
    posicionamento: Yup.number().required({ name: "posicionamento", err: "Campo com preenchimento obrigatório" }),
    apelido: Yup.string().max(255, {name: "apelido", err: "Precisa ter menos de 255 caracteres"}).required({ name: "apelido", err: "Campo com preenchimento obrigatório" }),
});
export default TreinamentoIACadastrarSchema;